var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "$";
Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
};
function loadfiltered(data1) {
  var current = $('.new_collection_filter');
  var next_url = current.data('next-url');
  $.ajax({
      url: data1,
      type: 'GET',
      dataType: 'html',
  }).done(function(next) {
      var new_products = $(next).find('.new_collection_filter');

      current.html(new_products.html());
  });
  //active filter functionality
  if (
      $('.collection-filters__grid .collection-filter__item').hasClass(
          'eq-collection-filter-active'
      )
  ) {
      $('.collection-filters__grid .collection-filter__item').removeClass(
          'eq-collection-filter-active'
      );
  }
  var activeFilter = $(
      `.collection-filters__grid .collection-filter__item[onclick="loadfiltered('${data1}')"]`
  );
  if (activeFilter) {
      activeFilter.addClass('eq-collection-filter-active');
  }
}

function CollectionLoadFiltered(data2) {
    var current = $('.new_collection_page1');
    var updatedUrl = data2;

    $.ajax({
        url: updatedUrl, // Updated URL
        type: 'GET',
        dataType: 'html',
    }).done(function(next) {
        var new_products = $(next).find('.new_collection_page1');
        var collectionTitle = $(next).find('.new_collection_page1').attr('data-collection-title');
        var collectionDescription = $(next).find('.js-eq-description').html();
        var collectionDeskImage = $(next).find('.new_collection_page1').attr('data-desk-collection-image');
        var collectionMobImage = $(next).find('.new_collection_page1').attr('data-mob-collection-image');
        var faqHtml = $(next).find('.eq-faq-new--collection').html()
        var flargeColDesc = $(next).find('.eq-collection-des-sec').html();
        var flargeColDescNew = $(next).find('.eq-collection-des-new').html();
        var flargImgText = $(next).find('.eq-collection-img-and-content').html();
        var flargBestProduct = $(next).find('.eq-collection-best-selling').html();
        current.html(new_products.html());
        // $('.eq-collection-sec-heading--main h2').text(collectionTitle);
        $('.eq-new-collection-banner__content h1').text(collectionTitle);
        $('.js-eq-description').html(collectionDescription);
        $('.eq-new-collection-banner__img img.desktop-img').attr('src', collectionDeskImage);
        $('.eq-new-collection-banner__img img.mobile-img').attr('src', collectionMobImage);
        $('.eq-faq-new--collection').html(faqHtml);
        $('.eq-collection-des-sec').html(flargeColDesc);
         $('.eq-collection-des-new').html(flargeColDescNew);
        $('.collection_new_breadcrumbs--title span').text(collectionTitle);
        $('.eq-collection-img-and-content').html(flargImgText);
        $('.eq-collection-best-selling').html(flargBestProduct)
         $('body').removeClass('overflow-hidden-mobile');
         $('.js-eq-collection-img-and-content__list').Cuttr({
            //options here
            truncate: 'characters',
            length: 639,
            readMore: true,
            readMoreText: '+ Read more',
            readLessText: '- Read less',
            ending: '',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        $('.vegan-collection-desc').Cuttr({
            //options here
            truncate: 'characters',
            length: 2000,
            readMore: true,
            readMoreText: '+ Read more',
            readLessText: '- Read less',
            ending: '',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        $('.js-decoration .metafield-rich_text_field').Cuttr({
            //options here
            truncate: 'characters',
            length: 1350,
            readMore: true,
            readMoreText: 'Read More',
            readLessText: 'Read Less',
            ending: '...',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        $('.js-tinctures-decoration .metafield-rich_text_field').Cuttr({
            truncate: 'characters',
            length: 1050,
            readMore: true,
            readMoreText: 'Read More',
            readLessText: 'Read Less', 
            ending: '...',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        $('.js-thc-products-decoration .metafield-rich_text_field').Cuttr({
            truncate: 'characters',
            length: 1000,
            readMore: true,
            readMoreText: 'Read More',
            readLessText: 'Read Less', 
            ending: '...',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        $('.js-thc-high-decoration .metafield-rich_text_field').Cuttr({
            truncate: 'characters',
            length: 1000,
            readMore: true,
            readMoreText: 'Read More',
            readLessText: 'Read Less', 
            ending: '...',
            readMoreBtnPosition: 'inside',
            readMoreBtnTag: 'a',
        });
        if ($('.eq-collection-best-selling__content').length > 0) {
            $('.eq-collection-best-selling__content .box__img').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .product-title').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .cannabinoids-field').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .cannabinoids-saving-field').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .benefits-field').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .details-field').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .price-field').matchHeight({
            byRow: true,
            });
            $('.eq-collection-best-selling__content .strength-flavor-field').matchHeight({
            byRow: true,
            });
        };
        if (history.pushState) {
            history.pushState(null, null, data2);
        } else {
            console.warn('Your browser does not support pushState.');
        }

        // Ensure the .js-eq-description p elements are ready before applying changes
        $(".js-eq-description p").each(function () {
            let fullText = $(this).text().trim(); // Store full text
           
            let words = fullText.split(" "); // Split text into words
            if(words != ''){
            let truncatedText = words.slice(0, 39).join(" ") + ""; // Show only the first 40 words
            $(this).data("full-text", fullText).data("truncated-text", truncatedText).text(truncatedText);
            $('.description').removeClass('js_blank_text');
            }else{
                $('.description').addClass('js_blank_text');
            }
            // Add Read More/Read Less button after each paragraph
          
        });

        // Use event delegation to handle clicks on dynamically loaded elements
        $(document).on('click', '.toggle-text', function () {
            let $p = $(this).prev("p"); // Get the paragraph before the button
            let isTruncated = $p.text() === $p.data("truncated-text");

            if (isTruncated) {
                $p.text($p.data("full-text"));
                $(this).text("Read Less");
            } else {
                $p.text($p.data("truncated-text"));
                $(this).text("Read More");
            }
        });
    });

    // Active filter functionality
    if ($('.eq-collection-tab__wrap .box').hasClass('tab-active')) {
        $('.eq-collection-tab__wrap .box').removeClass('tab-active');
    }
    var activeFilter = $(
        `.eq-collection-tab__wrap .box[onclick="CollectionLoadFiltered('${data2}')"]`
    );
    if (activeFilter) {
        activeFilter.addClass('tab-active');
    }
}


$( document ).ready(function() {
   
  
    // $('.search-input').on('input',searchDelay(function(){
    //     jQuery.getJSON("/search/suggest.json", {
    //     "q": $(this).val(),
    //     "resources": { 
    //         "type": "product",
    //         "limit": 10,
    //         }
    //     }).done(function(response) {
    //           var html = '<div class="result-search eq-search-data__result-wrap">';
    //           var products = response.resources.results.products;
    //         if(response.resources.results.products.length === 0){
    //             html += `
    //             <p class="eq-search-data__text"> No Result!</p>
    //             `;
    //         } else {
    //           products.map(function(item, index){
    //             text = item.body.substr(0, 10);
    
    //             if(item.image !== null){
    
    //               html += `
    //               <a class="d-block eq-search-data__product" href="${item.url}">
    //                   <img width="50px" class="eq-search-data__product-image" src="${item.image}">
    //                   <span class="eq-search-data__product-text">${item.title}</span>
    //               </a>`
    //             } else {
    //                html += `
    //               <a class="d-block" href="${item.url}">
    //                   <span>${item.title}</span>
    //               </a>`
    //             }
    //           })
    //         }
    //           html += '<div/>';
    //         $('.search-complete').html(html);
    //           $('.remove').addClass('active');
    //     });
    // }, 1000))

    $('.eq-blog-search-input').on('input', searchDelay(function () { 
        $('.blog-search-complete').css('display', 'block');
        jQuery.getJSON("/search/suggest.json", {
            "q": $(this).val(),
            "resources": {
                "type": "article",
                "limit": 10,
            }
        }).done(function (response) {
            var html = '<div class="result-search eq-search-data__result-wrap">';
            var articles = response.resources.results.articles;
    
            if (articles.length === 0) {
                html += `
                <p class="eq-search-data__text"> No Result!</p>
                `;
            } else {
                articles.map(function (item) {
                    let snippet = item.body.substr(0, 100); // Display a snippet of the article body
                    if (item.image !== null) {
                        html += `  <a class="d-block eq-search-data__article" href="${item.url}">
                            <img width="50px" class="eq-search-data__article-image" src="${item.image}&width=150" alt="${item.title}">
                             <span class="eq-search-data__product-text">${item.title}</span>
                        </a>`;
                    } else {
                        html += `  <a class="d-block eq-search-data__article" href="${item.url}">
                            <img width="50px" class="eq-search-data__article-image" src="https://cdn.shopify.com/s/files/1/0265/5164/8355/files/empty-state-media.svg" alt="${item.title}">
                             <span class="eq-search-data__product-text">${item.title}</span>
                        </a>`;
                    }
                });
            }
    
            html += '</div>';
            $('.blog-search-complete').html(html);
            $('.remove').addClass('active');
        });
    }, 1000));
    
    
    
    function searchDelay(callback, ms) {
        var timer = 0;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                callback.apply(context, args);
            }, ms || 0);
        };
    }
    
    $('.remove').click(function() {
        $('.result-search').remove();
        $(this).removeClass('active');
    })

    $(document).on('change', `.js-cw-product-page-form [data-option-1], .js-cw-product-page-form [data-option-2],.js-cw-product-page-form [data-option-3]`, function (e) {
        let option1 = option2 = option3 = null;
        if ($(`.js-cw-product-page-form [data-option-1]`).length > 0) {
           option1 = $(`.js-cw-product-page-form [data-option-1] option:selected`).val();
        }
        if ($(`.js-cw-product-page-form [data-option-2]`).length > 0) {
           option2 = $(`.js-cw-product-page-form [data-option-2] option:selected`).val();
        }
        if ($(`.js-cw-product-page-form [data-option-3]`).length > 0) {
           option3 = $(`.js-cw-product-page-form [data-option-3] option:selected`).val();
        }
        let variant_id = null;
        let current_selected_option = null;
        if (option2 == null & option3 == null) {
  
           current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`);
           variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}']`).val();
        }
        if (option2 != null & option3 == null) {
  
           current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`);
           variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}']`).val();
        }
        if (option2 != null & option3 != null) {
  
           current_selected_option = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`);
           variant_id = $(`.js-cw-product-page-form select.actual-variants option[data-option1='${option1}'][data-option2='${option2}'][data-option3='${option3}']`).val();
        }
        if (variant_id == null) {
           $(`.js-cw-product-page-form .stock`).fadeOut(100);
           $(`.js-cw-product-page-form .js-out-stock`).fadeIn(100);
           $(`.js-cw-product-page-form .product_page_atc`).addClass('soldout');
           $(`.js-cw-product-page-form .product_page_atc span`).text("Unavailable");
           return true;
        }
        let price = $(current_selected_option).attr('data-price');
        let compare_at_price = $(current_selected_option).attr('data-compareat-price');
        let discount = $(current_selected_option).attr('data-discount');
        let itemQty = $(current_selected_option).attr('data-qty');
        let afterPayPrice = $(current_selected_option).attr('data-afterpayprice')
        let save = $(current_selected_option).attr('data-save');
        let is_available = $(current_selected_option).attr('data-available');
        let subscriptionPercentage = $(current_selected_option).attr('data-sub-per');
        let variantPrice = $(current_selected_option).attr('data-money_without-currency-price');
        let discountPrice = parseFloat((variantPrice * subscriptionPercentage) / 100);
        let subscriptionPrice = variantPrice - discountPrice;
        let savPercentage = $(current_selected_option).attr('data-save-per');
        let savePrice = $(current_selected_option).attr('data-save-price')
        console.log('discountPrice Price ' + subscriptionPrice)
      
        // $('.js_save_price').text(savePrice);
        //$('.subscription-price').html(Shopify.formatMoney(subscriptionPrice, $('body').data('money-format')));
        $('.js_afterpay').attr('data-amount', price);
        $(`.js_after_pay`).attr('data-price', afterPayPrice);
        let setAfterPayPrice = $('.js_after_pay').attr('data-price');
        let dividaedPrice = (setAfterPayPrice / 4).toFixed(2); 
         
        if(save != ''){
            $(`.js_save_price`).html('save ' + save);
            $(`.js_save_price_wrap`).show();
            $('.js_save_percentage').text(savPercentage);
            $('.eq-discount-offer--wrapper').show();
        }else{
            $(`.js_save_price_wrap`).hide();
            $('.eq-discount-offer--wrapper').hide();
        }
        
        $(`.js_after_pay`).html('$' + dividaedPrice);
        $(`.js-cw-product-page-form select.actual-variants`).val(variant_id).trigger('change'); 
        // $(`.js-cw-product-page-form .js-compare-price`).text(compare_at_price);
        $(`.product__info-container s`).text(compare_at_price);
        $(`.js-price`).text(price);
        $(`.js-compare-price`).text(price);
        $(`.js-otp--price`).text(price);
        $(`.js_sticky_price`).html(price);
        $(`.js_sticky_price`).html(price);
        if(compare_at_price){
        $(`.js-compare-price`).html(compare_at_price);
        $(`.js_sticky_comprice`).html(compare_at_price);
        $(`.js-compare-price`).show();
        $(`.js_sticky_comprice`).show();
       }else{
          $(`.js-compare-price`).hide();
          $(`.js_sticky_comprice`).hide();
       }
        $(`.js-cw-product-page-form .js_discount`).text('Save ' + discount + '%');
        $(`.jsproqty`).text(itemQty);
        if (is_available == 'true') {
           $(`.js_pdp_atc`).text("Add to Cart");
           $(`.js_pdp_atc`).css("pointer-eventes", "all");
           $(`.js_pdp_atc`).css("opacity", "1");
        } else {
            $(`.js_pdp_atc`).css("pointer-eventes", "none");
            $(`.js_pdp_atc`).css("opacity", "0.5");
            $(`.product_page_atc span`).text("Soldout");
        }
        let current_position = null;
        cw.variants.forEach((em,ix) => {
        	if( em.id == variant_id && em.featured_image != null ) {
        		current_position = em.featured_image.position - 1;
        		$(`.probig`).slick('slickGoTo',current_position);
        	}
        });
  
        // let currentVarImagePath = $(current_selected_option).attr('data-image');
        // let featSrc = ''; // Declare outside the loop
        // $(".js_images").each(function() {
        //     featSrc = $(this).attr('data-new-image'); // Remove let to update the existing variable
        //     if (currentVarImagePath == featSrc) {
        //         console.log('matched');
        //         $(this).trigger('click');
        //         return false;
        //     }
        // });
  
        var newurl =
           window.location.protocol +
           '//' +
           window.location.host +
           window.location.pathname +
           '?variant=' +
           variant_id;
        window.history.replaceState({
           path: newurl
        }, '', newurl);
        /*
        console.log(variant_id);
        console.log(price);
        console.log(compare_at_price);
        console.log(discount);
        console.log(image_src);
        console.log(save);
        */
     });

     $(document).on('click', '.js_pdp_atc, .js_buy_now', function(e) {
        e.preventDefault();
       
        let varId = $('.js_product_var_change option:selected').val();
        let qty = $('.pdp-qty').val();
        let data = {}; // Declare the data object outside the conditional block
    
        let subscriptionRadioLength = $('#rc_purchase_type_autodeliver:checked').length;
    
        if (subscriptionRadioLength > 0) {
            let sellingPlanId = $('.selling-plan-selector option:selected').val();
            data = {
                id: varId,
                quantity: qty,
                selling_plan: sellingPlanId
            };
        } else {
            data = {
                id: varId,
                quantity: qty
            };
        }
        
        $.ajax({
            url: "/cart/add.js",
            method: "POST",
            data: data,
            dataType: "json",
            success: function(data) {
                // window.location = "/cart";
            },
            error: function(xhr, status, error) {
                console.error("Error adding to cart:", error);
                console.error("Response Text:", xhr.responseText);
                window.alert(xhr.responseJSON.description);
            }
        });
    });
    $('.option-selector option:checked').trigger('change');

    /*
    let productPrice =  $('.js_product_var_change option:selected').attr('data-price');
    let productSubPrice =  $('.js_product_var_change option:selected').attr('data-sub-price');
    console.log('Subscription price ' + productSubPrice)
    if(productSubPrice != ''){
        $('.js-price').html(productSubPrice); 
    }else{
        $('.js-price').html(productPrice); 
    }
    $('input[name="purchase_type"]').on('click', function () {
        if ($(this).is(':checked')) {
            let inputValue = $(this).attr('data-val'); // Get the value of the currently checked radio button
            console.log(inputValue);
            
            if(inputValue == 'subscription'){
                $('[data-option-subsave] .rc-radio__input').trigger('click');
                $('.js-price').html(productSubPrice);
             }else{
                $('[data-selector-onetime] .rc-radio__input').trigger('click');
                $('.js-price').html(productPrice);
             }
        }
     });

     */
    function updatePdpPriceByPurchaseType() {
        let productPrice = $('.js_product_var_change option:selected').attr('data-price');
        let productSubPrice = $('.js_product_var_change option:selected').attr('data-sub-price');
        let selectedPurchaseType = $('input[name="purchase_type"]:checked').attr('data-val');

        if (selectedPurchaseType === 'subscription') {
            $('[data-option-subsave] .rc-radio__input').trigger('click');

            if (productSubPrice) {
            $('.js-price').html(productSubPrice);
            }
        } else {
            $('[data-selector-onetime] .rc-radio__input').trigger('click');

            if (productPrice) {
            $('.js-price').html(productPrice);
            }
        }
        }

        $('input[name="purchase_type"]').on('change', updatePdpPriceByPurchaseType);
        $('.js_product_var_change, .option-selector').on('change', updatePdpPriceByPurchaseType);

        updatePdpPriceByPurchaseType();
    
  $('input[name="updates[]"]').on('change', function (e) {
        e.preventDefault();
        $('#cart').submit();
      });

$(".eq-search-result").slice(0, 12).css('display', 'block');
      if($('.eq-product_item').length > 0){
        $('.eq-search_filter') .val('eq-product_item').trigger('change'); 
      }
     else if($('.eq-page_item').length > 0){
        $('.eq-search_filter') .val('eq-page_item').trigger('change'); 
     }
     else if($('.eq-article_item').length > 0){
        $('.eq-search_filter') .val('eq-article_item').prop('selected', true).trigger('change'); 
     }
});

function removeDuplicateProducts() {
    const seenTitles = {};

    $('.eq-search-result').each(function() {
        const productTitle = $(this)
            .find('.product-card__title a')
            .text()
            .trim()
            .toLowerCase();

        if (!productTitle) return;

        if (seenTitles[productTitle]) {
            $(this).remove();
            console.log('Removed duplicate:', productTitle);
        } else {
            seenTitles[productTitle] = true;
        }
    });
}

$(document).on('click', '.js-load-more--search', function(e) {
    e.preventDefault();
    removeDuplicateProducts();
    var selectedClass = $('.eq-search_filter option:selected').val();
   
    var hiddenItems = $('.' + selectedClass + ':hidden');
    hiddenItems.slice(0, 12).slideDown();
    hiddenItems.slice(0, 12).parent('.eq-search-result').slideDown();
    if ($('.' + selectedClass + ':hidden').length === 0) {
        $(this).fadeOut('slow');
    }
    $('html,body').animate({
        scrollTop: $(this).offset().top()
    }, 1200);
});

$(document).ready(function () {
    removeDuplicateProducts();

    const productItemLength = $('.product-card.eq-product_item').length;
    const articleItemLength = $('.article-card-wrapper.eq-article_item').length;
    const pageItemLength = $('.article-card-wrapper.eq-page_item').length;

    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get('type');

    let count;

    if (type === 'article') {
        count = articleItemLength;
    } else if (type === 'page') {
        count = pageItemLength;
    } else if (type === 'product') {
        count = productItemLength;
    } else {
        switch ($('.eq-search_filter').val()) {
            case 'eq-article_item':
                count = articleItemLength;
                break;

            case 'eq-page_item':
                count = pageItemLength;
                break;

            case 'eq-product_item':
            default:
                count = productItemLength;
                break;
        }
    }

    $('.search-filter__left .search-count').text(count);
});

$(document).on('change', '.eq-search_filter', function(e) {
    //(".eq-search-result").slice(0, 12).slideDown();
    removeDuplicateProducts();
    var selectedClass = $(this).val();
    $('.eq-search-result').css('display', 'none');
    $('.eq-search-result .eq-product_item').css('display', 'none');
    $('.eq-search-result .eq-page_item').css('display', 'none');
    $('.' + selectedClass).slice(0, 12).css('display', 'block');
    $('.' + selectedClass).slice(0, 12).parent('.eq-search-result').css('display', 'block');
    if ($('.' + selectedClass).parent('.eq-search-result').length > 12) {
        $(".js-load-more--search").show();
    } else {
        $(".js-load-more--search").hide();
    }
    setTimeout(function() {
        if (selectedClass == 'eq-product_item' && $('.eq-product_item').length === 0) {

            $('#emptyItemMsg').show();
        } else if (selectedClass == 'eq-page_item' && $('.eq-page_item').length == 0) {
            $('#emptyItemMsg').show();
        } else if (selectedClass == 'eq-article_item' && $('.eq-article_item').length == 0) {
            $('#emptyItemMsg').show();
        } else {
            $('#emptyItemMsg').hide();
        }
    }, 500);
});




$(document).on('change', '.explore-collection-variant', function(e) {
    e.preventDefault();
    let parent = $(this).closest('.eq-explore-collection__col');
    let nowPrice = $(this).find(':selected').attr('data-price');
    let wasPrice = $(this).find(':selected').attr('data-price');
    let discountedPrice = $(this).find(':selected').attr('data-discounted-price');
    let finalDiscPrice = nowPrice - discountedPrice;
    let variantImage = $(this).find(':selected').attr('data-image');
    
    parent.find('.eq-explore-collection__price-main').html(
        Shopify.formatMoney(finalDiscPrice, $('body').data('money-format'))
    );
    parent.find('.eq-explore-collection__price-discount').html(
        Shopify.formatMoney(wasPrice, $('body').data('money-format'))
    );
   // parent.find('.eq-explore-collection__img img').attr('src', variantImage);
    
});
$(document).on('click', '.eq-explore-col-atc', function(e) {
    e.preventDefault();
    $('#CartPopup').css('display', 'none');
    $('#UpcartPopupBackDrop').remove();
    let parent = $(this).closest('.eq-explore-collection__col');
    let variantId =  parent.find('.explore-collection-variant').val();
    let discountCode = $(this).attr('data-discount-code');
    window.location = "/cart/" + variantId + ":1?discount=" + discountCode;
});

$(document).ready(function() {
    // window.upcartOnCartLoaded = function(cart) {
    //     // Retrieve the total item count from the cart object
    //     var totalItemCount = cart.item_count;
    //     // Update the HTML element displaying the cart count
    //     $('.eq-header__icon-count').text(totalItemCount);
    // };
    window.upcartOnCartLoaded = function (cart) {
        var count = cart.item_count;
        var label = 'Cart, ' + count + (count === 1 ? ' item' : ' items');

        $('.eq-header__icon-count').text(count);
        $('.eq-header__icon-link[href="/cart"]').attr('aria-label', label);
    };
    $(".js-eq-description p").each(function() {
        let fullText = $(this).text().trim(); // Store full text
        let words = fullText.split(" "); // Split text into words
         
        if (words != '') {
            let truncatedText = words.slice(0, 39).join(" ") + ""; // Show only the first 40 words
            $(this).data("full-text", fullText).data("truncated-text", truncatedText).text(truncatedText);
            $('.description').removeClass('js_blank_text');
        }else{
            $('.description').addClass('js_blank_text');
        }
        // Toggle text on button click
        $(document).on('click', '#toggle-text', function() {
            let $p = $(".js-eq-description p");
            if ($p.text() === $p.data("truncated-text")) {
                $p.text($p.data("full-text"));
                $(this).text("Read Less");
            } else {
                $p.text($p.data("truncated-text"));
                $(this).text("Read More");
            }
        });
    });

   
    
    $(document).on("change", ".cannabinoids_filter", function() {
        if ($(this).is(":checked")) {
            let dataURL = $(this).attr("data-col-url");
            window.location.href = dataURL;
        }
    });
    // setTimeout(function() {
    //   $('.subscription-radio').append(`<ul><li>Save 30% On February’s Subscription Orders</li><li>Save 20% On All Future Subscription Orders&nbsp;</li><li>Easily Modify, Pause, Or Cancel At Any Time</li><li>Double Reward Points on Your First Order</li><li>Guaranteed Product Availability</li><li>Never Have to Remember to Place An Order</li></ul>`);
    // }, 2000);
});
 



$(document).on("click", ".js_mobile_popup", function() {
    $('.mobile-facets__close').click();
});

$(document).on("click", ".feedback-form--submit", function(e) {
	e.preventDefault();
	let purchaseReasons = $('.feedback-question--1').attr('data-question');
	let purchaseReasonsValue = [];
	let shoppingExperience = $('.feedback-question--2').attr('data-question');
	let purchaseReasonsOther = $('#otherTextarea').val();
	let shoppingExperienceValue = $('input[name="experience"]:checked').val();
	let highlightFeedback = $('.feedback-question--3').attr('data-question');
	let highlightFeedbackValue = $('#hearMore').val();
	let suggestions = $('.feedback-question--4').attr('data-question');
	let suggestionsValue = $('#doneBetter').val();
	let aboutFeedback = $('.feedback-question--5').attr('data-question');
	let aboutFeedbackValue = $('input[name="contact"]:checked').val();
	let emailAddress = $('input[name="email"]').val();
    let fullName = $('input[name="name"]').val();
	let customerData = {};
	let queryparameters;
	let currentUrl = window.location.href;
	if (currentUrl.includes("?")) {
		queryparameters = currentUrl.split("?")[1];
		console.log("queryparameters:", queryparameters);
		sessionStorage.setItem("queryparameters", queryparameters);
		queryparameters.split("&").forEach((param) => {
			const [key, value] = param.split("=");
			customerData[key] = decodeURIComponent(value || ""); // Handle URL encoding
		});
	}

    if ($('.feeback_checkbox:checked').length === 0 && $('.feeback_other_checkbox:checked').length === 0) {
        $('.question1--error').show();
        return; // Stop further execution
    }  else if ($('#otherTextarea').is(':visible') && purchaseReasonsOther === '') {
        console.log('Other textarea is visible and blank');
        $('.question1--error').show();
        $('.question1--error').text(`This field can't be blank`);
        return;
    } else{
        $('.question1--error').hide();
    }
    

    if (highlightFeedbackValue === '') { 
          $('.question3--error').show();
          return;
    }else{
           $('.question3--error').hide();
    }
    $('input[type="checkbox"]:checked').each(function() {
		purchaseReasonsValue.push($(this).val());
	});
	if ($('input[name="other"]').is(':checked')) {
		customerData[purchaseReasons] = purchaseReasonsOther;
	} else {
		customerData[purchaseReasons] = purchaseReasonsValue;
	}
	customerData[shoppingExperience] = shoppingExperienceValue;
	customerData[highlightFeedback] = highlightFeedbackValue;
	customerData[suggestions] = suggestionsValue;
	customerData[aboutFeedback] = aboutFeedbackValue;
	console.log("aboutFeedbackValue " + aboutFeedbackValue)
	if (aboutFeedbackValue == 'Yes') {
        customerData["Full Name"] = fullName;
		customerData["Email Address"] = emailAddress;
	}
	console.log('customerData ', customerData)
	$.ajax({
		url: "https://ip.joyorganics.com/contact",
		method: "POST",
		dataType: "JSON",
		contentType: "application/json; charset=utf-8",
		data: JSON.stringify(customerData),
		success: function(data) {
			console.log("submittted form data", customerData);
			$('.eq-feedback-form').hide();
            $('.thanks-for-feedback').show();
            
			
		},
		error: function(data) {
			
		},
	});
});
$(document).on('change', 'input[name="other"]', function () {
  if ($(this).is(':checked')) {
    $('.eq-feedback-textarea--hide').show();
  } else {
    $('.eq-feedback-textarea--hide').hide();
  }
});

 
$(document).on('click', '.yotpo-summary-footer, .yotpo-sr-bottom-line-button', function (e) {
  e.preventDefault();
    $('#app-review').trigger('click'); 
    $('html, body').animate({
        scrollTop: $('#app-review').offset().top + 100
    }, 10)
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.hash === '#pdp-testimonial') {
  
  setTimeout(function() {
    const section = document.querySelector('#pdp-testimonial');
     $('#app-review').trigger('click'); 
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
       
    }
    history.replaceState(null, null, window.location.pathname + window.location.search);
    }, 2000);
  }
});

document.addEventListener('DOMContentLoaded', () => {
    const iconWrapper = document.getElementById('product-customize-iconWrapper');
    const popover = document.getElementById('product-customize-popover');
	document.querySelectorAll('.info-icon-wrapper .product-customize-icon-wrapper').forEach(wrapper => {
		wrapper.addEventListener('click', function (e) {
			e.stopPropagation(); // Prevent body click closing immediately
            const arrow = document.querySelector('.next-arrow.slick-arrow');
            if (arrow) {
              arrow.style.zIndex = '0';
            }

			const popover = this.querySelector('.info-icon-wrapper .product-customize-popover');
			const isVisible = popover.style.display === 'block';
                            
			// Hide all popovers
			document.querySelectorAll('.product-customize-popover').forEach(pop => {
			pop.style.display = 'none';
			});

			// Toggle: If already visible → hide, else → show
			if (!isVisible) {
			popover.style.display = 'block';
			}
		});
	});

		// OPTIONAL: Click outside to close
	document.addEventListener('click', function () {
		document.querySelectorAll('.product-customize-popover').forEach(pop => {
			pop.style.display = 'none';
		});
	});

    // Hide the popover when clicking outside
    window.addEventListener('click', (event) => {
		if(iconWrapper != undefined && popover != undefined && iconWrapper != null && popover != null) {
			if (!iconWrapper.contains(event.target) && !popover.contains(event.target)) {
				popover.style.display = 'none';
			}
		}
    });
});

$(document).ready(function () {
  $('.js_salve_review_btn').on('click', function (e) {
    e.preventDefault();

    var $widget = $('.salve-product-reviwe');

    if ($widget.is(':hidden')) {
      // Open
      $widget.stop(true, true).slideDown(600, function () {
        $('html, body').animate(
          { scrollTop: $widget.offset().top - 100 },
          500
        );
      });
    } else {
      // Close
      $widget.stop(true, true).slideUp(600);
    }
  });
});